export default __webpack_public_path__ + "media/images/75-94b869ae595eb02ed13e7af5ea60f7db.jpg";